import { http } from '@/http/axios.js'
import axios from 'axios'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { dateFormat } from '@/utils/index.js'
import { showScreenLoading, hideScreenLoading } from '@/http/loading.js'
import { Message } from 'element-ui'

// 列表
export function getListAPI(params) {
  return http({
    url: '/admin/order/mall/page',
    method: 'get',
    params
  })
}
// 详情
export function getDetailAPI(orderNo) {
  return http({
    url: '/admin/order/detail',
    method: 'get',
    params: { orderNo }
  })
}

// 发货
export function handleDeliveryAPI(data) {
  return http({
    url: '/admin/order/delivery',
    method: 'post',
    data
  })
}
// 订单取消
export function handleOrderCancelAPI(orderNo) {
  return http({
    url: '/admin/order/cancel',
    method: 'post',
    data: { orderNo }
  })
}
// 下载合同
export function downloadOrderContractAPI(orderNo) {
  return http({
    url: '/admin/order/contract/download',
    method: 'post',
    data: { orderNo }
  })
}
// 统计
export function getOrderStaticAPI() {
  return http({
    url: '/admin/order/mall/status/stat',
    method: 'get'
  })
}
// 全部导出
export function DownloadAPI(data) {
  showScreenLoading()
  axios({
    method: 'post',
    url: '/api/admin/order/mall/export',
    responseType: 'blob',
    data,
    headers: {
      Authorization: getToken() || ''
    }
  })
    .then(async res => {
      hideScreenLoading();
      let data = res.data;
      let url = window.URL.createObjectURL(new Blob([data]));
      let a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      let filename = `果冻租订单列表${dateFormat()}.xlsx`;
      a.setAttribute('download', decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click(); //执行下载
      window.URL.revokeObjectURL(a.href); //释放url
      document.body.removeChild(a); //释放标签
    })
    .catch(error => {
      hideScreenLoading();
    })
}

// 下载文件1
export function downFile(url, name) {
  getBlob(url).then(blob => {
    saveAs(blob, name)
  })
}
function getBlob(url) {
  return new Promise(resolve => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = () => {
      if (xhr.status == 200) {
        resolve(xhr.response)
      }
    }
    xhr.send()
  })
}
function saveAs(blob, name) {
  var link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = name
  link.click()
}
// 下载文件2
export function downloadPDF(pdfUrl, name) {
  showScreenLoading()
  axios({
    url: pdfUrl,
    method: 'GET',
    responseType: 'blob' // 必须指定为blob类型才能下载
  }).then(
    res => {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', name)
      document.body.appendChild(link)
      link.click()
      hideScreenLoading()
    },
    reason => {
      hideScreenLoading()
      Message.error('下载失败！')
    }
  )
}
// 完成订单
export function handleCompleteAPI(data) {
  return http({
    url: '/admin/order/complete',
    method: 'post',
    data
  })
}
// 首付明细
export function getOfflinePayDetailAPI(orderNo) {
  return http({
    url: '/admin/order/prepay/detail',
    method: 'get',
    params: { orderNo }
  })
}
// 提交首付
export function submitOfflinePayAPI(orderNo) {
  return http({
    url: '/admin/order/prepay/offlinePay',
    method: 'post',
    data: { orderNo }
  })
}
// 提前归还
export function handleAheadReturnAPI(data) {
  return http({
    url: '/admin/order/aheadReturn',
    method: 'post',
    data,
  });
}
// 查询订单售后状态
export function getAfterSaleStatusAPI(orderNo) {
  return http({
    url: '/admin/order/afterSale/status',
    method: 'get',
    params: { orderNo },
  });
}
// 更新订单售后状态
export function submitAfterSaleStatusAPI(data) {
  return http({
    url: '/admin/order/afterSale/status/edit',
    method: 'post',
    data,
  });
}
